import {keys} from 'ts-transformer-keys';
import {Condition} from '~/shared/src/utilities/condition';

export type EditorConfig = {
    schema? : Schema;
    valueSetId? : number;
    valueUnit? : string;
    condition? : Condition
};
export const editorConfig = keys<EditorConfig>();
